import { createHttpClient, type TokenStore } from '@/lib/api-client';
import type { AuthTokens } from '@/lib/shared-types';

const STORAGE_KEY = 'venue.tokens';

/** localStorage-backed tokens so a refresh survives a page reload. */
export const tokenStore: TokenStore = {
  get() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as AuthTokens) : null;
    } catch {
      return null;
    }
  },
  set(tokens) {
    if (tokens) localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
    else localStorage.removeItem(STORAGE_KEY);
  },
};

export const api = createHttpClient({
  baseURL: import.meta.env.VITE_API_URL ?? '/api',
  tokenStore,
  locale: localStorage.getItem('venue.locale') ?? 'en',
  onUnauthorized: () => {
    tokenStore.set(null);
    if (!location.pathname.startsWith('/login')) location.href = '/login';
  },
});
